<template>
  <div style="height: 100%">
    <div class="img">
      <!-- <img src="../assets/images/login_background.svg" alt="" /> -->
    </div>
    <div class="opacity_wrapper"></div>
    <div class="form_container">
      <div class="section1">
        <div class="section_header_wrap">
          <div @click="goBack" class="back_btn_box">
            <img src="../assets/images/procedure//icon_arrow-left_black.svg" />
            <div>뒤로</div>
          </div>
          <img class="img_logo" src="../assets/images/joyworks_logo3.png" style="cursor: pointer" @click="goHome" alt="" />
        </div>
        <div class="text_box">
          <div class="user_text">
            <span class="text_highlight">{{ userInfo?.EMP_NO }}</span> 님
          </div>
          <div class="detail_title_text">A/S 현재 진행 현황</div>
        </div>
      </div>
      <div class="section2">
        <div v-for="data in repairList" :key="data.SEQ_NO" @click="detailPage(data)" class="list_box">
          <div class="list_time">{{ data.DATES }}</div>
          <div class="list_text">
            <span class="text_hightlight_black">{{ data.ITM_NAME }}</span> 상품 AS가 <span class="text_hightlight_blue">{{ data.E_STATUS }}</span> 되었습니다.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import router from "@/router";
import repairAPI from "@/api/repairAPI";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import authAPI from "@/api/authAPI";
const store = useStore();
const userInfo = ref();
const repairList: any = ref([]);
const detailPage = (data: any) => {
  console.log("data", data);
  router.push({ name: "clientDetail", params: { SEQ_NO: data.SEQ_NO } });
};
const checkSession = () => {
  authAPI
    .checkSession()
    .then((res: any) => {
      console.log(res);
      const data = res.data.data;
      if (data.result == "FAIL") {
        router.push({ name: "clientLogin" });
      }
    })
    .catch((error: any) => {
      console.log(error);
      alert(error);
    });
};

onMounted(() => {
  checkSession();
  userInfo.value = store.getters.getUserInfo;
  repairAPI.GetRepair({ CUS_HP_NO: userInfo.value.EMP_NO }).then((res: any) => {
    repairList.value = res.data.data;
    console.log("repairtList", repairList.value);
  });
});
const goHome = () => {
  router.push({ name: "clientHome" });
};
const goBack = () => {
  router.go(-1);
};
</script>
<style scoped>
.section_header_wrap {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 26px;
}
.section_header_wrap > img {
  height: 26px;
}
.section_header_wrap > div:nth-child(2) {
  height: 26px;
}
.back_btn_box {
  display: flex;
  align-items: center;
  float: left;
  cursor: pointer;
}
.section_header_wrap > img:last-child {
  margin-left: calc(50% - 110px);
  margin-right: auto;
}

.opacity_wrapper {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
  position: fixed;
  top: 0px;
  left: 0px;
}
.form_container {
  background: white;
  position: fixed;
  top: calc(0%);
  right: calc(10%);
  width: 382px;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.img {
  height: 940px;
}
.img > img {
  width: 100%;
  height: 100%;
}
.section1 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  min-height: 160px;
  padding: 30px 30px 32px 30px;
}
.img_logo {
  width: 110px;
  height: 26px;
}
.text_box {
  display: flex;
  gap: 4px;
  flex-direction: column;
}
.user_text {
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
  line-height: 23px;
  letter-spacing: -0.5px;
}
.text_highlight {
  color: #006da1;
  font-family: "Noto Sans CJK KR-Bold";
}
.detail_title_text {
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 20px;
  line-height: 23px;
  letter-spacing: -0.5px;
}
.section2 {
  padding: 30px 40px 30px 40px;
  height: 100%;
  gap: 30px;
  display: flex;
  flex-direction: column;
  background-color: #f9f9f9;
}
.list_box {
  display: flex;
  flex-direction: column;
  gap: 6px;
  border-bottom: 1px solid #999999;
  padding-bottom: 30px;
  cursor: pointer;
}
.list_time {
  font-size: 12px;
  font-family: "Noto Sans CJK KR-Medium";
  color: #999999;
  line-height: 18px;
}
.list_text {
  font-family: "Noto Sans CJK KR-Medium";
  font-size: 14px;
  line-height: 21px;
}
.text_hightlight_black {
  font-family: "Noto Sans CJK KR-Bold";
}
.text_hightlight_blue {
  font-family: "Noto Sans CJK KR-Bold";
  color: #006da1;
}
.button_box {
  margin-top: auto;
}
.button_text {
  width: 100%;
  font-size: 16px;
  font-family: "Noto Sans CJK KR-Bold";
  color: #ffffff;
  line-height: 22px;
  text-align: center;
  background-color: #006da1;
  border-radius: 6px;
  padding: 13px 118px 13px 118px;
  cursor: pointer;
}
</style>
